import { Layout, notification } from 'antd';
import PropTypes from 'prop-types';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Utils } from '../../tools/utils';
import { getIsInactive, queryMerchantsAgreementStatus, refusedSignedAgreement } from '../common/api';
import { LoginAction } from "../login/actions";
import Breads from './breads';
import PromptSceneBar from './clues';
import './content.less';
import MyModal, { agreementOrRejection, merchantsType, publicOrPrivate, topResponsiblePerson } from './promotionServiceAgreement/index';
const { Content } = Layout;

class SiderDemo extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      collapsed: document.body.clientWidth < 500,
      selectedKeys: ['1'],
      //提示语控制
      clues: {
        showClues: false,
        isConfirm: false,
        typeClues: merchantsType.协议到期商户,
        date: ''
      },
      //协议控制
      agreement: {
        showAgreement: false,
        isClose: false,
        typeAgreement: merchantsType.协议到期商户
      },
      isShowInactive:false
    };
    this.textBar = React.createRef();
  }
  componentDidMount() {
    this.initAgreement();
    getIsInactive(Utils.getOrgId()).then(res=>{
        if(Utils.getOrgId() !=='1336272313067585536'){
            this.setState({isShowInactive:!res.data.data})
        }
    })
  }

  //初始化协议及提示语状态
  initAgreement = async () => {
    const { location: { pathname } } = this.props;
    const isClose = sessionStorage.getItem('isClose');
    if (pathname === '/productRepository' || pathname === '/policySys/onlinePolicy' || pathname === '/myIncome') {
      const { data: { data } } = await queryMerchantsAgreementStatus(Utils.getOrgId(), Utils.getUserId());
      const signAgreementEndTime = data.signAgreementEndTime ? data.signAgreementEndTime : null;
      let signAgreementSource = data.signAgreementSource + '';
      let signAgreementType = data.signAgreementType + '';
      const signFlag = data.signFlag;
      const orgSignType = data.orgSignType;

      if (!(signAgreementSource == merchantsType.新商户) && signFlag === topResponsiblePerson.不是顶级负责人) {
        this.setState({ ...this.state, clues: { ...this.state.clues, showClues: false }, agreement: { ...this.state.agreement, showAgreement: false } });
        return;
      };

      if (orgSignType === publicOrPrivate.对公商户) {
        if (signAgreementSource == merchantsType.取消下发协议商户 || signAgreementSource != merchantsType.公转私商户) {
          this.setState({ ...this.state, clues: { ...this.state.clues, showClues: false }, agreement: { ...this.state.agreement, showAgreement: false } });
          return;
        }
        if (isClose) {
          this.setState(state => {
            if (signAgreementType == agreementOrRejection.已经签署) {
              return { ...state, clues: { showClues: false, ...state.clues }, agreement: { showAgreement: false, ...state.agreement } }
            } else if (signAgreementType == agreementOrRejection.拒绝签署) {
              return { ...state, clues: { showClues: true, isConfirm: false, typeClues: merchantsType.拒绝签署商户, date: signAgreementEndTime ? signAgreementEndTime : '' }, agreement: { showAgreement: false, isClose: true, typeAgreement: merchantsType.拒绝签署商户, date: signAgreementEndTime ? signAgreementEndTime : '' } }
            } else {
              return { ...state, clues: { showClues: true, isConfirm: signAgreementType == agreementOrRejection.拒绝签署 ? false : true, typeClues: signAgreementType == agreementOrRejection.拒绝签署 ? merchantsType.拒绝签署商户 : signAgreementSource, date: signAgreementEndTime ? signAgreementEndTime : '' }, agreement: { showAgreement: false, isClose: signAgreementSource == merchantsType.新商户 ? false : true, typeAgreement: signAgreementSource, date: signAgreementEndTime ? signAgreementEndTime : '' } }
            }
          });
        }
        else {
          this.setState((state) => {
            if (signAgreementType == agreementOrRejection.已经签署) {
              return { ...state, clues: { showClues: false, ...state.clues }, agreement: { showAgreement: false, ...state.agreement } }
            } else if (signAgreementType == agreementOrRejection.拒绝签署) {
              return { ...state, clues: { showClues: true, isConfirm: false, typeClues: merchantsType.拒绝签署商户, date: signAgreementEndTime ? signAgreementEndTime : '' }, agreement: { showAgreement: false, isClose: true, typeAgreement: merchantsType.拒绝签署商户, date: signAgreementEndTime ? signAgreementEndTime : '' } }
            } else {
              if (signAgreementSource == merchantsType.新商户) {
                return { ...state, clues: { showClues: false, isConfirm: false, typeClues: merchantsType.新商户, date: signAgreementEndTime ? signAgreementEndTime : '' }, agreement: { showAgreement: true, isClose: false, typeAgreement: merchantsType.新商户, date: signAgreementEndTime ? signAgreementEndTime : '' } }
              } else if (signAgreementSource == merchantsType.公转私商户) {
                return { ...state, clues: { showClues: true, isConfirm: true, typeClues: merchantsType.公转私商户, date: signAgreementEndTime ? signAgreementEndTime : '' }, agreement: { showAgreement: true, isClose: true, typeAgreement: merchantsType.公转私商户, date: signAgreementEndTime ? signAgreementEndTime : '' } }
              }
            }
          });
        }
      }
      if (orgSignType === publicOrPrivate.对私商户) {
        if (signAgreementSource == merchantsType.取消下发协议商户) {
          let thirtyDay = 1000 * 60 * 60 * 24 * 30;
          let curDate = new Date().getTime();
          let endTime = new Date(signAgreementEndTime).getTime();
          if (thirtyDay > (curDate - endTime) && thirtyDay > Math.abs(curDate - endTime)) {
            signAgreementSource = merchantsType.历史团队版商户;
            signAgreementType = agreementOrRejection.待签署;
          } else {
            signAgreementType = agreementOrRejection.已经签署;
          }
        }
        if (isClose) {
          this.setState(state => {
            if (signAgreementType == agreementOrRejection.已经签署) {
              return { ...state, clues: { showClues: false, ...state.clues }, agreement: { showAgreement: false, ...state.agreement } }
            } else if (signAgreementType == agreementOrRejection.拒绝签署) {
              return { ...state, clues: { showClues: true, isConfirm: false, typeClues: merchantsType.拒绝签署商户, date: signAgreementEndTime ? signAgreementEndTime : '' }, agreement: { showAgreement: false, isClose: true, typeAgreement: merchantsType.拒绝签署商户, date: signAgreementEndTime ? signAgreementEndTime : '' } }
            } else {
              return { ...state, clues: { showClues: true, isConfirm: signAgreementType == agreementOrRejection.拒绝签署 ? false : true, typeClues: signAgreementType == agreementOrRejection.拒绝签署 ? merchantsType.拒绝签署商户 : signAgreementSource, date: signAgreementEndTime ? signAgreementEndTime : '' }, agreement: { showAgreement: false, isClose: signAgreementSource == merchantsType.新商户 ? false : true, typeAgreement: signAgreementSource, date: signAgreementEndTime ? signAgreementEndTime : '' } }
            }
          });
        }
        else {
          this.setState((state) => {
            if (signAgreementType == agreementOrRejection.已经签署) {
              return { ...state, clues: { showClues: false, ...state.clues }, agreement: { showAgreement: false, ...state.agreement } }
            } else if (signAgreementType == agreementOrRejection.拒绝签署) {
              return { ...state, clues: { showClues: true, isConfirm: false, typeClues: merchantsType.拒绝签署商户, date: signAgreementEndTime ? signAgreementEndTime : '' }, agreement: { showAgreement: false, isClose: true, typeAgreement: merchantsType.拒绝签署商户, date: signAgreementEndTime ? signAgreementEndTime : '' } }
            } else {
              if (signAgreementSource == merchantsType.新商户) {
                return { ...state, clues: { showClues: false, isConfirm: false, typeClues: merchantsType.新商户, date: signAgreementEndTime ? signAgreementEndTime : '' }, agreement: { showAgreement: true, isClose: false, typeAgreement: merchantsType.新商户, date: signAgreementEndTime ? signAgreementEndTime : '' } }
              } else if (signAgreementSource == merchantsType.历史团队版商户) {
                return { ...state, clues: { showClues: true, isConfirm: true, typeClues: merchantsType.历史团队版商户, date: signAgreementEndTime ? signAgreementEndTime : '' }, agreement: { showAgreement: true, isClose: true, typeAgreement: merchantsType.历史团队版商户, date: signAgreementEndTime ? signAgreementEndTime : '' } }
              } else if (signAgreementSource == merchantsType.协议到期商户) {
                return { ...state, clues: { showClues: true, isConfirm: true, typeClues: merchantsType.协议到期商户, date: signAgreementEndTime ? signAgreementEndTime : '' }, agreement: { showAgreement: true, isClose: true, typeAgreement: merchantsType.协议到期商户, date: signAgreementEndTime ? signAgreementEndTime : '' } }
              } else if (signAgreementSource == merchantsType.公转私商户) {
                return { ...state, clues: { showClues: true, isConfirm: true, typeClues: merchantsType.公转私商户, date: signAgreementEndTime ? signAgreementEndTime : '' }, agreement: { showAgreement: true, isClose: true, typeAgreement: merchantsType.公转私商户, date: signAgreementEndTime ? signAgreementEndTime : '' } }
              }
            }
          });
        }
      }
      this.getShowStyle(pathname);
    } else return;
  };

  getShowStyle(pathname) {
    if (!this.textBar.current) return;
    let { style } = this.textBar.current;
    switch (pathname) {
      case '/productRepository':
        //产品库
        style.marginTop = '10px';
        style.marginBottom = '10px';
        return;
      case '/policySys/onlinePolicy':
        //线上保单
        style.marginTop = '10px';
        return;
      case '/myIncome':
        //我的收入
        style.marginTop = '24px';
        style.marginRight = '64px';
        style.marginLeft = '24px';
        style.minWidth = '1024px';
        return;
    };
  };

  clickConfirm = () => {
    this.removeClose();
    this.setState({ agreement: { ...this.state.agreement, showAgreement: true } });
  };

  protocolDialogClosed = (type) => {
    if (type === agreementOrRejection.已经签署) {

      this.setState({ agreement: { ...this.state.agreement, showAgreement: false }, clues: { ...this.state.clues, showClues: false } });
      this.removeClose();
      notification.success({
        message: <p style={{ 'color': '#333' }}>恭喜您，签署成功</p>,
        duration: 4,
      });
    }
    else if (type === agreementOrRejection.拒绝签署) {
      refusedSignedAgreement(Utils.getOrgId()).then((res) => {
        const { data } = res;
        if (data.status === 200) {
          this.setState({ agreement: { ...this.state.agreement, showAgreement: false }, clues: { ...this.state.clues, showClues: true, isConfirm: false, typeClues: merchantsType.拒绝签署商户 } });
        }
      })
    }
    else if (type === agreementOrRejection.待签署) {
      if (!sessionStorage.getItem('isClose')) { sessionStorage.setItem('isClose', JSON.stringify(true)); }
      this.setState({ agreement: { ...this.state.agreement, showAgreement: false }, clues: { ...this.state.clues, showClues: true } });
    }
  };
  removeClose = () => {
    if (sessionStorage.getItem('isClose')) {
      sessionStorage.removeItem('isClose');
    }
  };


  render() {
    let { clues: { showClues, isConfirm, typeClues, date }, agreement,isShowInactive } = this.state;
    return (
      <Layout
        style={{ position: "relative" }}
      >
        {
          showClues &&
          <div className='prompt-scene-bar' ref={this.textBar}>
            <PromptSceneBar
              show={showClues}
              isConfirm={isConfirm}
              type={typeClues}
              date={date}
              clickConfirm={this.clickConfirm}
            />
          </div>
        }
        {isShowInactive &&
          <PromptSceneBar
            show={true}
            isConfirm={''}
            type={'inactive'}
          />
        }
        <Breads token={this.props.token} disabled={!!this.props.disabled} />
        <Content
          className='ant-layout-content_'
          style={{
            marginTop: this.props.marginTop || '10px',
            padding: this.props.padding || '10px',
            background: this.props.background || '#fff',
            display: 'flex',
          }}>
          {this.props.children}
        </Content>
        <MyModal
          show={agreement.showAgreement}
          isClose={agreement.isClose}
          typeAgreement={agreement.typeAgreement}
          protocolDialogClosed={this.protocolDialogClosed}
          date={agreement.date}
        />
      </Layout>
    );
  }
}

function mapState(state) {
  return {
    token: state.token
  }
}
SiderDemo.propTypes = {
  marginTop: PropTypes.string,
  padding: PropTypes.string,
  background: PropTypes.string
}
export default withRouter(connect(mapState, { ...LoginAction })(SiderDemo))
